import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import '@/lib/vh'

import '@/styles/main.scss'

import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import Rollbar from 'rollbar'
import type { LogArgument } from 'rollbar'
import { createApp } from 'vue'

import App from '@/App.vue'
import { RETRIVE_UPDATE_TIME } from '@/constants/times'
import router from '@/router'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

Sentry.init({
  app,
  enabled: import.meta.env.MODE === 'production',
  environment: import.meta.env.VITE_ENV || 'production',
  dsn: 'https://dda50f11cb21456d8be242fd648269c5@o1382323.ingest.us.sentry.io/4508675647930368',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

app.mount('#app')

async function fetchAppStatus() {
  const response = await fetch('/app-status.json', {
    cache: 'no-store',
    headers: {
      cache: 'no-store',
      'cache-control': 'no-cache'
    }
  })

  if (response?.status === 200) {
    const { lastUpdate } = await response.json()
    const persistedLastUpdate = localStorage.getItem('lastUpdate')
    localStorage.setItem('lastUpdate', lastUpdate)
    if (persistedLastUpdate && lastUpdate > persistedLastUpdate) {
      window.location.reload()
    }
  }
}

if (import.meta.env.PROD) {
  fetchAppStatus()
  setInterval(fetchAppStatus, RETRIVE_UPDATE_TIME)
}

const rollbar = new Rollbar({
  enabled: import.meta.env.PROD,
  accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: import.meta.env.VITE_ROLLBAR_ENV,
    client: {
      javascript: {
        code_version: '1.0',
        source_map_enabled: true
      }
    }
  }
})

app.provide('$rollbar', rollbar)

app.config.errorHandler = err => {
  rollbar.error(err as LogArgument)
  throw err
}
